import { BusinessPurpose } from '@ebalance/proto/bfftypes/v1/business_purpose_pb'
import { LicenseType } from '@ebalance/proto/bfftypes/v1/license_type_pb'
import i18next from 'i18next'

import type { BusinessMasterRow } from '~/hooks/businessMaster/useListBusinessMasters'
import type { CsvColumnDef } from '~/pages/AdminOcctoMaster/tabs/_common/models/csvExport'

const NO_VALUE = '—'
const SEPARATOR = '、'

export function licenseTypeLabel(value: LicenseType): string {
  const t = i18next.t.bind(i18next)
  switch (value) {
    case LicenseType.GENERATION:
      return t('page:adminOcctoMaster.businessMaster.licenseType.generation')
    case LicenseType.RETAIL:
      return t('page:adminOcctoMaster.businessMaster.licenseType.retail')
    case LicenseType.TRANSMISSION:
      return t('page:adminOcctoMaster.businessMaster.licenseType.transmission')
    case LicenseType.DR:
      return t('page:adminOcctoMaster.businessMaster.licenseType.dr')
    case LicenseType.SELF_WHEELING:
      return t('page:adminOcctoMaster.businessMaster.licenseType.selfWheeling')
    case LicenseType.UNSPECIFIED:
      return NO_VALUE
    default:
      return NO_VALUE
  }
}

// LicenseType の配列を表示用文字列に変換する。 backend 返却順をそのまま尊重し、
// 「、」 区切りで連結する。 空配列の場合は "—" を返す。
export function licenseTypesLabel(values: readonly LicenseType[]): string {
  if (values.length === 0) {
    return NO_VALUE
  }
  return values.map(licenseTypeLabel).join(SEPARATOR)
}

export function businessPurposeLabel(value: BusinessPurpose): string {
  const t = i18next.t.bind(i18next)
  switch (value) {
    case BusinessPurpose.NORMAL:
      return t('page:adminOcctoMaster.businessMaster.purpose.normal')
    case BusinessPurpose.BATTERY:
      return t('page:adminOcctoMaster.businessMaster.purpose.battery')
    case BusinessPurpose.PUMPED_HYDRO:
      return t('page:adminOcctoMaster.businessMaster.purpose.pumpedHydro')
    case BusinessPurpose.SELF_WHEELING:
      return t('page:adminOcctoMaster.businessMaster.purpose.selfWheeling')
    case BusinessPurpose.UNSPECIFIED:
      return NO_VALUE
    default:
      return NO_VALUE
  }
}

/**
 * 事業者マスタタブの CSV エクスポート カラム定義
 * (spec AC-012b / design doc §5「タブ別 CSV カラム」)。
 */
export function businessMasterCsvColumns(): Array<
  CsvColumnDef<BusinessMasterRow>
> {
  return [
    {
      headerKey: 'page:adminOcctoMaster.businessMaster.column.businessCode',
      accessor: (row) => row.businessCode,
    },
    {
      headerKey: 'page:adminOcctoMaster.businessMaster.column.businessName',
      accessor: (row) => row.businessName,
    },
    {
      headerKey: 'page:adminOcctoMaster.businessMaster.column.licenseTypes',
      accessor: (row) => licenseTypesLabel(row.licenseTypes),
    },
    {
      headerKey: 'page:adminOcctoMaster.businessMaster.column.purpose',
      accessor: (row) => businessPurposeLabel(row.purpose),
    },
  ]
}
